import { getMyEmployerActiveLeaseChartData } from "../../../../api/dossier/getMyEmployerActiveLeaseChartData";
import { ActiveLeaseChartDatum } from "../../../../types/Chart";
import APChart from "../APChart";

const EmployerActiveLeasesChart = () => {
  return (
    <APChart
      type="line"
      chartTitle="Active Leases"
      getData={() => getMyEmployerActiveLeaseChartData<ActiveLeaseChartDatum>()}
      xAxisOptions={{ type: "time" }}
      yAxisOptions={{ type: "count" }}
      dimensions={[
        { key: "date", label: "Date" },
        { key: "activeLeases", label: "Leases" },
      ]}
      isAreaChart={true}
    />
  );
};

export default EmployerActiveLeasesChart;
